const DEVELOPMENT_CONFIG = {
    //base_url: "https://kxmbz6w1sc.execute-api.us-east-2.amazonaws.com/prod/api",
    // base_url: "https://zk5f9iji22.execute-api.us-east-2.amazonaws.com/Stage/api",
    //base_url: 'https://localhost:44384/api',
    // 'https://api.notenetic.com/api',
    base_url: process.env.REACT_APP_API_SERVER ? process.env.REACT_APP_API_SERVER : 'https://api.dev.notenetic.com/api',
    prod_base_url: 'https://api-prod.notenetic.com/api',
    statusCode: 200,
    unAuthorized: 401,
    noPermission: 403,
    internalServer: 500,
    internalServerError: 501,
    internalServerBadGateway: 502,
    TOKEN: "token",
    OTP_TOKEN: "otpToken",
    REFRESH_TOKEN: "refeshtoken",
    LOGIN_TIME: "loginTime",
    TOKEN_EXPIRETIME: "accessTokenExpireTime",
    REFRESHTOKEN_EXPIRETIME: "refeshTokenExpireTime",
    LAST_URL: "lasturl",
    IS_TEMP_PASSWORD: "isTemp",
    APP_VERSION: "appVersion",
    IS_IMPERSONATE: "false",
    STAFF_ID:"staffId",
    CLINIC_ID:"clinicId"
  };
  export default process.env.NODE_ENV === "development" ? DEVELOPMENT_CONFIG : DEVELOPMENT_CONFIG;
  
  